import { render, staticRenderFns } from "./AdminHomeView.vue?vue&type=template&id=0662b4a1&scoped=true&"
import script from "./AdminHomeView.vue?vue&type=script&lang=js&"
export * from "./AdminHomeView.vue?vue&type=script&lang=js&"
import style0 from "./AdminHomeView.vue?vue&type=style&index=0&id=0662b4a1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0662b4a1",
  null
  
)

export default component.exports